import { ArtistRoutesEnum } from 'src/Router/ArtistComponentsNewUI'
import { CampaignPlatformTypeEnum } from 'src/Types/campaigns'
import { ScheduleSteps } from 'src/Types/ui'

const getScheduleRoute = (platform: CampaignPlatformTypeEnum): string => {
  if (platform === CampaignPlatformTypeEnum.TIKTOK) {
    return ArtistRoutesEnum.TiktokSchedule
  }
  if (platform === CampaignPlatformTypeEnum.META) {
    return ArtistRoutesEnum.AdsSchedule
  }
  return ArtistRoutesEnum.SpotifySchedule
}

const getDetailsRoute = (platform: CampaignPlatformTypeEnum): string => {
  if (platform === CampaignPlatformTypeEnum.TIKTOK) {
    return ArtistRoutesEnum.TiktokDetails
  }
  if (platform === CampaignPlatformTypeEnum.META) {
    return ArtistRoutesEnum.MetaAdsDetails
  }
  return ArtistRoutesEnum.SpotifyDetails
}

export const getCampaignCheckoutRoute = (
  platform: CampaignPlatformTypeEnum,
  campaignId: number,
): string =>
  `${getScheduleRoute(platform)}/${campaignId}?step=${ScheduleSteps.CHECKOUT}`

export const getCampaignDetailsRoute = (
  platform: CampaignPlatformTypeEnum,
  campaignId: number,
): string => `${getDetailsRoute(platform)}/${campaignId}`
